import { RealtimeHandlerRegistry } from "./RealtimeHandlerRegistry";

// Общий реестр приложения: в него регистрируются фичи, из него читает RealtimeProvider.
export const realtimeHandlers = new RealtimeHandlerRegistry();
